import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { fetchCategories } from '@actions/helpCenter';
import Categories from '@cont/HelpCenter/Categories';
import Tickets from '@cont/HelpCenter/Tickets';
import { HELP_AND_SUPPORT } from '@constants/segment';
import setupInitialProps from '@utils/setupInitialProps';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import HelpCenterLayout from '@layout/HelpCenterLayout/HelpCenterLayout';

const HelpCenter = () => {
  const title = 'Unacademy Help Center';
  const description = 'Help Center';

  const canonicalURL = 'https://unacademy.com/helpcenter';

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title,
          description,
          url: canonicalURL
        }}
      />
      <Head>
        <title>{title}</title>
        <link
          href="https://cdn.in-freshbots.ai/assets/share/css/chat-combined.min.css?v=0.26"
          rel="stylesheet"
        />
      </Head>
      <Categories />
      <Tickets />
    </>
  );
};

HelpCenter.pageInfo = {
  name: HELP_AND_SUPPORT,
  isMWebSupported: true,

  layoutOptions: {
    disableDarkMode: true,
    hideIntercom: true
  }
};

HelpCenter.getInitialProps = setupInitialProps(async ({ store }) => {
  const { auth } = store.getState();
  const goalUid = auth?.selectedGoal?.uid || '';
  const promises = [];
  promises.push(store.dispatch(fetchCategories({ goalUid })));
  await Promise.all(promises);
  return {};
}, HelpCenter.pageInfo);

export default HelpCenter;
HelpCenter.Layout = HelpCenterLayout;
HelpCenter.Wrapper = PageReduxProvider;
